import { ApplicationType } from '../types/translation-types';
import { LanguageManagementRepository } from '../data/language-management-repository';
import { ApplicationLanguagesResponse } from '../types/language-management-types';

/**
 * Get Application Languages Use Case
 * Retrieves languages configured for a specific application
 */
export class GetApplicationLanguagesUseCase {
  constructor(private readonly repository: LanguageManagementRepository) {}

  async execute(applicationType: ApplicationType): Promise<ApplicationLanguagesResponse> {
    return this.repository.getApplicationLanguages(applicationType);
  }
}
